import React from "react";
import MaterialIntro from "./MaterialIntro";
import MaterialContent from "./MaterialContent";
import { MaterialSection } from "./styled";

class Material extends React.Component {
  state = {
    tabList: this.props.data.types,
    currentTab: 0,
    name: "",
    subName: "",
    description: "",
    elements: []
  };

  componentWillMount() {
    this.setState({
      name: this.state.tabList[this.state.currentTab].name,
      subName: this.state.tabList[this.state.currentTab].subName,
      description: this.state.tabList[this.state.currentTab].description,
      elements: this.state.tabList[this.state.currentTab].elements
    });
  }

  changeTab = tab => {
    this.setState({ currentTab: tab.id }, this.handleTabChange);
  };

  handleTabChange() {
    this.setState({
      name: this.state.tabList[this.state.currentTab].name,
      subName: this.state.tabList[this.state.currentTab].subName,
      description: this.state.tabList[this.state.currentTab].description,
      elements: this.state.tabList[this.state.currentTab].elements
    });
  }

  render() {
    return (
      <MaterialSection className="section" background={this.props.background}>
        <MaterialIntro
          title={this.props.data.title}
          intro={this.props.data.intro}
        />
        <MaterialContent
          name={this.state.name}
          subName={this.state.subName}
          description={this.state.description}
          elements={this.state.elements}
          tabList={this.state.tabList}
          changeTab={this.changeTab}
          currentTab={this.state.currentTab}
        />
      </MaterialSection>
    );
  }
}

export default Material;



// WEBPACK FOOTER //
// ./src/pages/Materials/MaterialComponent/MaterialComponent.js